import { Component, inject, signal, WritableSignal } from '@angular/core';
import { disabled, email, form, FormField, FormRoot, required, submit } from '@angular/forms/signals';
import { RouterModule } from '@angular/router';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { LangToggleComponent } from '@app/shared/components/lang-toggle/lang-toggle.component';
import { AuthService } from '@app/shared/services/auth.service';
import { ForgotPasswordRequestBody } from '@app/shared/types/models/auth/auth.model';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  imports: [LangToggleComponent, FormField, FormRoot, TranslatePipe, RouterModule, UiButtonComponent, UiInputComponent],
  selector: 'proffeo-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent {
  private readonly authService: AuthService = inject(AuthService);

  protected readonly showSuccessAlert: WritableSignal<{ success: boolean; error: boolean }> = signal({
    success: false,
    error: false
  });
  protected readonly model = signal<ForgotPasswordRequestBody>({ email: '' });
  protected readonly form = form(this.model, path => {
    required(path.email, { message: 'forgot-password-email-address-is-required' });
    email(path.email, { message: 'forgot-password-please-enter-a-valid-email-address' });
    // The link is sent once: the address stays locked afterwards.
    disabled(path.email, () => this.showSuccessAlert().success);
  });

  protected onSubmitForm(): void {
    void submit(this.form, {
      action: async () => {
        try {
          await firstValueFrom(this.authService.forgotPassword(this.model()));
          this.showSuccessAlert.set({ success: true, error: false });
        } catch {
          this.showSuccessAlert.set({ success: false, error: true });
        }
      }
    });
  }
}
